import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilteredMultiSelect from "./FilteredMultiSelect";

export default class QuizPack extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    updatedQuizPack: {
      id: "",
      quizzes: [],
      packName: "",
    },
    quizzes: [],
    selectedQuizzes: [],
  };

  componentDidMount() {
    this.setState({
      updatedQuizPack: {
        ...this.props.quizPack,
      },
    });
    this.setState({ quizzes: this.props.quizzes });
  }

  handleEditSave = (event, quizPack, quizzes) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateQuizPack(quizPack, quizzes);
    this.setState({ selectedQuizzes: [] });
  };

  handleQuizSelectionChange = (selectedQuizzes) => {
    this.setState({ selectedQuizzes });
  };

  handleDeselectQuiz(index) {
    var selectedQuizzes = this.state.selectedQuizzes.slice();
    selectedQuizzes.splice(index, 1);
    this.setState({ selectedQuizzes });
  }

  handleQuizPackEdit = (event, quizPack) => {
    event.preventDefault();
    this.setState({
      selectedQuizzes: this.state.quizzes.filter((quiz) =>
        quizPack.quizzes?.includes(quiz.id)
      ),
    });
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      updatedQuizPack: {
        ...this.state.updatedQuizPack,
        [name]: value,
      },
    });
  }

  render() {
    return (
      <div className="tile is-near-half is-flex m-small box notification">
        <a
          href="/"
          onClick={(e) => {
            this.handleQuizPackEdit(e, this.props.quizPack);
          }}
          className="product-edit-icon"
        >
          <FontAwesomeIcon icon="edit" />
        </a>
        <button
          onClick={(event) =>
            this.props.handleDeleteQuizPack(this.props.quizPack.id, event)
          }
          className="delete"
        ></button>

        {this.state.isEditMode ? (
          <>
            <div className="column is-half">
              <p className="product-id">id: {this.props.quizPack.id}</p>
              <p>Navn</p>
              <input
                className="input is-medium"
                type="text"
                name="packName"
                value={this.state.updatedQuizPack.packName}
                onChange={this.handleInputChange}
              />
              <br />

              <button
                type="submit"
                className="button is-info is-small"
                onClick={(e) => {
                  this.handleEditSave(
                    e,
                    this.state.updatedQuizPack,
                    this.state.selectedQuizzes
                  );
                }}
              >
                Gem
              </button>
            </div>
            <div className="column is-half">
              <b>Vælg Quizzer</b>
              <FilteredMultiSelect
                onChange={this.handleQuizSelectionChange}
                options={this.props.quizzes}
                selectedOptions={this.state.selectedQuizzes}
                textProp="quizName"
                valueProp="id"
                className="activity-selector"
                placeholder="søg"
                buttonText="vælg"
              />
              {this.state.selectedQuizzes.length === 0 && (
                <p>(intet valgt endnu)</p>
              )}
              {this.state.selectedQuizzes.length > 0 && (
                <ul>
                  {this.state.selectedQuizzes.map((quiz, i) => (
                    <li key={quiz.id}>
                      {`${quiz.quizName} `}
                      <button
                        type="button"
                        onClick={() => this.handleDeselectQuiz(i)}
                      >
                        &times;
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="column is-half">
              <p className="product-title">{this.props.quizPack.packName}</p>
              <p className="product-id">
                <b>id:</b> {this.props.quizPack.id}
              </p>
            </div>

            <div className="column is-half">
              <p className="product-id">
                <b>Quizzer:</b>
                <br />
              </p>
              {this.props.quizPack.quizzes &&
                this.props.quizPack.quizzes.map((quiz) => {
                  if (!quiz) {
                    return;
                  }
                  const thisQuiz = this.state.quizzes.find((a) => {
                    return a.id == quiz;
                  });
                  return (
                    <div key={quiz} className="product-id">
                      {thisQuiz?.quizName}
                      <br />
                      <p className="weak"> {thisQuiz?.category}</p>
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
    );
  }
}
